import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import {
  DswPrimaryButtonComponent,
  DswSecondaryButtonComponent,
  DswSmallButtonDirective,
} from '@vi-succ/design-system-web';

@Component({
  selector: 'et-catalog-switch-confirmation',
  imports: [
    MatDialogModule,
    TranslateModule,
    DswPrimaryButtonComponent,
    DswSecondaryButtonComponent,
    DswSmallButtonDirective,
  ],
  templateUrl: './switch-confirmation.component.html',
  styleUrl: './switch-confirmation.component.scss',
})
export class SwitchConfirmationComponent {}
